(function () {
  const STYLES = `
    /* ========================================
     * Overflow containment
     * ======================================== */

    /* Constrain the BV root container so nothing bleeds past viewport */
    :host {
      display: block !important;
      max-width: 100% !important;
      overflow-x: hidden !important;
    }

    /* Rating Snapshot bars wrapper */
    #bv_review_maincontainer
      > div:nth-of-type(2)
      div[role="group"][aria-labelledby="bv-reviews-rating-snapshot-container"] {
      width: 100% !important;
      max-width: 100% !important;
      overflow-x: hidden !important;
    }

    /* ========================================
     * Typography
     * ======================================== */

    /* Main "Reviews" heading */
    h2 {
      font-family: Sink, var(--font-heading--family, sans-serif) !important;
      font-size: 32px !important;
      font-style: normal !important;
    }

    /* Section subheadings: Rating Snapshot, Overall Rating, etc. */
    #bv_review_maincontainer > :not(#reviews_container) h3 {
      font-size: 18px !important;
      font-style: normal !important;
    }

    /* Individual review title headings */
    #reviews_container section[id^="bv-review-"] h3 {
      font-family: Sink, var(--font-heading--family, sans-serif) !important;
      font-style: normal !important;
    }

    /* ========================================
     * Backgrounds — white per Figma design
     * ======================================== */

    /* Top summary cards (Rating Snapshot / Overall / Review this Product) */
    #bv_review_maincontainer > div:nth-of-type(2) > div:nth-of-type(1) > div,
    /* Average Customer Ratings card */
    #bv_review_maincontainer > div:nth-of-type(2) > div:nth-of-type(2),
    /* Per-review ratings side panel */
    #reviews_container section[id^="bv-review-"]
      > div
      > div
      > div:nth-of-type(2)
      > div
      > div:nth-of-type(2)
      > div {
      background-color: #ffffff !important;
    }

    /* Customer images placeholder area */
    #bv_review_maincontainer > div:nth-of-type(3) > div > div > div,
    #bv_review_maincontainer > div:nth-of-type(4) > div {
      background-color: #ffffff !important;
    }

    /* Brand-response area inside review cards */
    #reviews_container section[id^="bv-review-"] [aria-label*="Response from" i],
    #reviews_container section[id^="bv-review-"] [aria-label*="Brand Response" i] {
      background-color: #ffffff !important;
    }

    /* Pagination / review-count footer bar */
    #bv_review_maincontainer > div:nth-of-type(6),
    #bv_review_maincontainer > #reviews_container + div {
      background-color: #ffffff !important;
    }

    /* ========================================
     * Separators — lighter dividers
     * ======================================== */

    /* Main section dividers (between rating snapshot and avg ratings, etc.) */
    #bv_review_maincontainer > div:nth-of-type(2) > div {
      border-bottom-color: #dddddd !important;
    }

    /* Review-level dividers */
    #bv_review_maincontainer > div:nth-of-type(6),
    #bv_review_maincontainer > #reviews_container + div {
      border-bottom-color: #dddddd !important;
    }

    /* ========================================
     * Mobile overrides (≤ 767px)
     * ======================================== */
    @media (max-width: 767px) {

      /* Main "Reviews" heading — smaller on mobile per Figma */
      h2 {
        font-size: 24px !important;
      }

      /* Section subheadings — smaller on mobile per Figma */
      #bv_review_maincontainer > :not(#reviews_container) h3 {
        font-size: 14px !important;
      }

      /* Ensure all content stays within bounds */
      section,
      #reviews_container {
        max-width: 100% !important;
        overflow-x: hidden !important;
      }

      /* Rating-bar individual items — allow wrapping and fit within parent */
      #bv_review_maincontainer
        > div:nth-of-type(2)
        div[role="group"][aria-labelledby="bv-reviews-rating-snapshot-container"]
        > div[role="button"] {
        max-width: 100% !important;
        min-width: 0 !important;
      }

      /* Slider / bar elements — flexible width */
      #bv_review_maincontainer
        > div:nth-of-type(2)
        div[role="group"][aria-labelledby="bv-reviews-rating-snapshot-container"]
        div[role="presentation"] {
        min-width: 0 !important;
        max-width: 100% !important;
      }

      /* Overall ratings block */
      #bv-reviews-overall-ratings-container {
        min-width: 0 !important;
        max-width: 100% !important;
      }

      /* Search input — keep within bounds */
      input[type="text"] {
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
    }
  `;

  function injectStyles(shadowRoot) {
    if (shadowRoot.querySelector('[data-bv-override]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-bv-override', '');
    style.textContent = STYLES;
    shadowRoot.appendChild(style);
  }

  function constrainHost(el) {
    // The BV host sits inside a flex child (.shopify-block) whose
    // min-width defaults to "auto", letting BV's internal content
    // push the element wider than the grid column.  Fix that from
    // the light DOM so the shadow-DOM max-width: 100% can resolve
    // correctly.
    el.style.maxWidth = '100%';
    el.style.overflow = 'hidden';
    el.style.width = '100%';

    var parent = el.parentElement;
    if (parent) {
      parent.style.minWidth = '0';
      parent.style.maxWidth = '100%';
      parent.style.overflow = 'hidden';
    }
  }

  function tryInject() {
    var el = document.querySelector('[data-bv-show="reviews"]');
    if (el && el.shadowRoot) {
      constrainHost(el);
      injectStyles(el.shadowRoot);
      return true;
    }
    return false;
  }

  // Try immediately
  if (tryInject()) return;

  // Observe for the BV element to appear and get its shadow root
  var observer = new MutationObserver(function () {
    if (tryInject()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Safety timeout to stop observing after 30s
  setTimeout(function () {
    observer.disconnect();
  }, 30000);
})();
